// Роль «Инструменты» — узкий доступ: человек заходит в newats ради одной
// вкладки, расшифровки файлов, и больше ему здесь ничего не нужно и не
// доступно. Сервер такому пользователю отдаёт 403 на всё, кроме своего профиля
// и /api/tools/ (ats_api.auth.tools_role_allows) — здесь только о том, что ему
// показывать, чтобы он не утыкался в пустые экраны и ошибки.

import type { UserOut } from "@/api/client";

export const TOOLS_ROLE = "tools";

/** Единственный раздел такого пользователя. */
export const TOOLS_HOME = "/tools";

export function isToolsOnly(user: UserOut | null | undefined): boolean {
  return user?.role === TOOLS_ROLE;
}

/** Страницы, на которые такому пользователю вообще можно попасть. Всё
 *  остальное ведёт на «Инструменты»: сервер те страницы всё равно не наполнит,
 *  и пустой экран с ошибками выглядел бы поломкой, а не запретом. */
export function toolsRoleAllowsPath(pathname: string): boolean {
  return (
    pathname === TOOLS_HOME ||
    pathname === TOOLS_HOME + "/" ||
    // Свой профиль: имя, аватар, тема, ссылка на программу.
    pathname === "/settings" ||
    // Окна программы «HRDeva»: расшифровка файла и работа с видео на
    // компьютере (/tray/transcribe, /tray/tools и раздел «Инструменты» единого
    // окна /tray/app). Видео сервер не видит вовсе,
    // так что кому открыта расшифровка, тому открыты и склейка, сжатие, обрезка.
    // Шелла у окон программы нет, и увести оттуда «на свою страницу» некуда:
    // окна звонков и интервью (/tray, /tray/interviews) сами говорят такому
    // пользователю, что это ему не подключено (TrayApp, TrayInterviewsPage);
    // в едином окне такой пользователь видит один раздел «Инструменты»
    // (tray/appFlow.ts, appSections).
    pathname.startsWith("/tray")
  );
}
